import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getInverterLookup = createAsyncThunk("/thunk/get-inverter-list", async () => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-inverter-list`);
    return response;
  } catch (error) {
    throw error;
  }
});
